import React from "react";
import { useTranslation } from "react-i18next";
import { Dialog, DialogActions, DialogDescription, DialogTitle } from "src/components/base/dialog";
import { Button } from "src/components/base/button";
import { toast } from "react-toastify";
import { FullHeadscalePreAuthKey } from "src/api/generated/frontend_internal_v1";
import { ApiInternal } from "src/api/api_internal";

/**
 * The properties for {@link ExpirePreAutKeyDialog}
 */
export type ExpirePreAuthKeyDialogProps = {
    /** Callback for closing the popup */
    onClose: () => void;

    /** Callback for successful expire */
    onExpire: () => void;

    /** The key to expire */
    preAuthKey: FullHeadscalePreAuthKey;
};

/**
 * Dialog to expire the device key
 */
export default function ExpirePreAutKeyDialog(props: ExpirePreAuthKeyDialogProps) {
    const [t] = useTranslation("dialog-expire-pre-auth-key");
    const [tg] = useTranslation();

    /**
     * Expire a device key
     */
    const expireKey = async () => {
        await ApiInternal.preAuthKeys.expirePreAuthKey(props.preAuthKey.uuid);
        toast.success(t("toast.key-expired-successfully"));
        props.onClose();
    };

    return (
        <Dialog open={true} onClose={props.onClose}>
            <DialogTitle>{t("heading.expire-key")}</DialogTitle>
            <DialogDescription>{t("description.expire-key")}</DialogDescription>
            <DialogActions>
                <Button onClick={props.onClose}>{tg("button.cancel")}</Button>
                <Button color={"red"} onClick={async () => await expireKey()}>
                    {t("button.expire-key")}
                </Button>
            </DialogActions>
        </Dialog>
    );
}
